import { AppComponent } from './app/app.component';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import {
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ToastrModule } from '@shared/components/lib-ngx/ngx-toastr/toastr/toastr.module';
import { TranslocoRootModule } from '@shared/components/zaa-transloco-root/transloco-root.module';
import { AppRoutingModule } from './app/app.routing.module';
import { TuiRootModule } from '@taiga-ui/core';
import { CoreAuthModule } from '@features/auth/core-auth.module';
import {
  AUTHEN_POLICY_HUTECH,
  AUTHEN_POLICY_ROYAL,
  AUTHEN_POLICY_UEF,
} from '@config/authen.config';
import { AppHttpResponseInterceptor } from '@core/interceptors/app-response.interceptor';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { APP_BASE_HREF } from '@angular/common';
import { environment } from '@config/environments/environment';

const APP_BOOTSTRAP_CONFIG = {
  providers: [
    importProvidersFrom([
      // Core lib modules
      BrowserModule,
      AppRoutingModule,

      CoreAuthModule.forRoot(AUTHEN_POLICY_HUTECH),

      // Global modules
      TranslocoRootModule,
      ToastrModule.forRoot({ timeOut: 3000 }),
      TuiRootModule,
      AngularSlickgridModule.forRoot(),
    ]),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpResponseInterceptor,
      multi: true,
    },
    { provide: APP_BASE_HREF, useValue: environment.application.baseHref },
  ],
};

bootstrapApplication(AppComponent, APP_BOOTSTRAP_CONFIG)
  .then(() => {
    if (isDevMode()) {
      console.group(`Bootstrap Angular application success`);
    }
  })
  .catch((err) => {
    console.error(`Error when bootstrap application: ${err.message}`);
  });
